export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-fbq').forEach(function (el) {
      // <a class="js-fbq" data-on="click" data-event="add_to_cart" data-value="100">Add to Cart</a>
      if (typeof window.fbq === 'undefined') {
        return
      }
      let log_event = function (dom) {
        let event = dom.dataset.fbqEvent || dom.dataset.event
        let debug_mode = dom.dataset.debug || false
        if (event) {
          // let rule like add_to_cart to addToCart
          event = event
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join('')
          let value = dom.dataset.fbqValue || dom.dataset.value
          if (value) {
            if (value.startsWith('{') && value.endsWith('}')) {
              value = JSON.parse(value)
              if (dom.dataset.quantityEl && value.contents) {
                value.contents[0].quantity = parseInt(
                  document.querySelector(dom.dataset.quantityEl).value
                )
              }
              if (dom.dataset.valueEl) {
                let valueEl = document.querySelector(dom.dataset.valueEl)
                value.value = parseFloat(
                  valueEl.dataset.gaValue || valueEl.value
                ).toFixed(2)
              }
            }
            window.fbq('track', event, value)
          } else {
            window.fbq('track', event)
          }
          if (debug_mode) {
            alert(`FBQ: ${event} ${value}`)
          }
        }
      }
      if (el.dataset.on) {
        el.addEventListener(el.dataset.on, function () {
          log_event(this)
        })
      } else {
        log_event(el)
      }
    })
  })
})()
